import { Component, Input, OnInit } from '@angular/core';
import { AppConfig } from '../../../../config/routes.config';
import { ModalController, NavController } from '@ionic/angular/standalone';
import { PaymentInfo } from 'src/shared/models/payment.model';
import { BookingHelperService } from 'src/shared/services/helpers/booking-helper.service';
import { GeolocationService } from 'src/shared/services/helpers/geolocation.service';
import { take } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { IonButton } from "@ionic/angular/standalone";

@Component({
	selector: 'vl-payment-successfull',
	templateUrl: './payment-successful.component.html',
	styleUrls: ['./payment-successful.component.scss'],
	imports: [IonButton, TranslatePipe, NgIf],
})
export class PaymentSuccessfulComponent implements OnInit {
	isSuccess;
	message;
	routes = AppConfig.routes;
	returnUrl;
	@Input() paymentInfo: PaymentInfo;

	constructor(private modalCtrl: ModalController,
				private bookingHelper: BookingHelperService,
				private geolocationService: GeolocationService,
				private navCtrl: NavController) {
	}

	ngOnInit() {
	}


	setState(isSuccess, returnUrl?: string) {
		this.returnUrl = returnUrl;
		this.isSuccess = isSuccess;
		if (isSuccess) {
			this.message = 'payment.alerts.success';
		} else {
			this.message = 'payment.alerts.error';
		}
	}

	async openSupport() {
		this.geolocationService.getGroupsObs().pipe(take(1)).subscribe(g => {
			const group = g?.find(v => v.id == this.paymentInfo.groupId);
			this.bookingHelper.openSupport(group || null);
		});
	}

	async action() {
		try {
			await this.modalCtrl.dismiss();
		}
		catch (e) {
			await this.navCtrl.navigateRoot('/' + this.routes.home.fullPath);
		}

		// const redirectUrl = await this.storage.getItem(StorageEnums.PurchaseRedirectUrl);
		// console.log(redirectUrl);
		// if (redirectUrl && redirectUrl !== 'null') {
		// 	return this.navCtrl.navigateRoot('/' + redirectUrl);
		// }
		// if (this.isSuccess) {
		// 	this.navCtrl.navigateRoot('/' + this.routes.home.fullPath);
		// } else {
		// 	this.navCtrl.navigateRoot('/' + this.routes.home.fullPath);
		// }
	}
}
